import React from 'react';
import { Modal, Button, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Logo from '../../../assets/images/logo-landing.png';
import './styles.scss';
import { injectIntl } from 'react-intl';

@injectIntl
class Main extends React.Component {
  constructor(props) {
    super(props);
    const { show, callback } = props;

    this.state = {
      show,
      callback:
        callback == null
          ? () => document.getElementById('igheader-tooltip-button').click()
          : callback
    };
  }

  hide = () => {
    this.setState({ show: false });
  };

  onHide = () => {
    const { onHide } = this.props;

    this.hide();
    onHide();
  };

  takeTour = () => {
    this.hide();
    this.state.callback();
  };

  renderExtraInformationLink = () => {
    const { extraInformationLink } = this.props;

    return <a href={extraInformationLink}>Extra information</a>;
  };

  renderTourButton = () => (
    <Button id="take-tour-btn" bsStyle="primary" onClick={this.takeTour}>
      {this.props.intl.formatMessage({ id: 'take_tour' })}
    </Button>
  );

  render() {
    const { show } = this.state;

    const {
      title,
      children,
      closeButton,
      extraInformationLink,
      callback
    } = this.props;

    return (
      <Modal
        className="instructional-modal"
        title={title}
        show={show}
        onHide={this.onHide}
      >
        <Modal.Header closeButton={closeButton}>
          <Modal.Title className="update-title">
            <div className="ig-logo-navbar">
              <img src={Logo} style={{ maxWidth: '100%' }} />
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{children}</Modal.Body>
        {(document.getElementById('igheader-tooltip-button') != null ||
          callback) && (
          <Modal.Footer>
            <Col xsHidden xs={4}>
              {extraInformationLink && this.renderExtraInformationLink()}
            </Col>
            <Col className="text-center" xs={12}>
              {this.renderTourButton()}
            </Col>
          </Modal.Footer>
        )}
      </Modal>
    );
  }
}

Main.defaultProps = {
  show: true,
  closeButton: true,
  callback: null,
  extraInformationLink: null
};

Main.propTypes = {
  title: PropTypes.string,
  show: PropTypes.bool,
  closeButton: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  callback: PropTypes.func,
  extraInformationLink: PropTypes.string
};

export default Main;
